import React, { useEffect } from 'react';

const MAX_RELOAD_ATTEMPTS = 3;
const RELOAD_ATTEMPT_KEY = 'chunkReloadAttempts';

const CHUNK_URL_PATTERN = /^(\d+|[a-zA-Z0-9_-]+)\.[a-f0-9]+\.(css|chunk\.js)$/i;

const isChunkError = (error) =>
  error instanceof Error &&
  (error.name === 'ChunkLoadError' ||
    /Loading (CSS )?chunk .* failed/i.test(error.message || '') ||
    (error.message?.includes('Loading chunk') && error.message?.includes('failed')));

const isChunkResourceUrl = (url) => {
  if (!url || typeof url !== 'string') return false;
  try {
    const pathname = new URL(url, window.location.origin).pathname;
    const filename = pathname.split('/').pop() || '';
    return CHUNK_URL_PATTERN.test(filename);
  } catch {
    return false;
  }
};

const ChunkErrorHandler = ({ children }) => {
  useEffect(() => {
    sessionStorage.removeItem(RELOAD_ATTEMPT_KEY);

    const reload = () => {
      const attempts = parseInt(sessionStorage.getItem(RELOAD_ATTEMPT_KEY) || '0');
      if (attempts < MAX_RELOAD_ATTEMPTS) {
        sessionStorage.setItem(RELOAD_ATTEMPT_KEY, String(attempts + 1));
        window.location.reload();
      }
    };

    const handleError = (event) => {
      if (isChunkError(event.error)) {
        reload();
        return;
      }
      const target = event.target;
      if (target?.nodeName === 'LINK' || target?.nodeName === 'SCRIPT') {
        const url = target.href || target.src;
        if (isChunkResourceUrl(url)) reload();
      }
    };

    const handleUnhandledRejection = (event) => {
      if (isChunkError(event.reason)) {
        event.preventDefault();
        reload();
      }
    };

    window.addEventListener('error', handleError);
    window.addEventListener('unhandledrejection', handleUnhandledRejection);

    return () => {
      window.removeEventListener('error', handleError);
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
    };
  }, []);

  return children;
};

export default ChunkErrorHandler;
